import { alphanumericSort } from 'src/pages/analytics/simulator/innovation/utils/utils';
import { Grid, Typography } from '@mui/material';
import { MultiSelect } from 'react-multi-select-component';
import { ISelectOption } from 'src/lib';
import '../../../filters/components/filters.scss';
import './multi-select.scss';

interface IHorizontalSelectProps {
  label: string;
  value: ISelectOption[];
  options: ISelectOption[];
  isDisabled: boolean;
  handleChange: (value: ISelectOption[]) => void;
  handleBlur: (expandedState) => void;
  // eslint-disable-next-line react/require-default-props
  limit?: number;
  // eslint-disable-next-line react/require-default-props
  error?: string;
  // eslint-disable-next-line react/require-default-props
  isMultiSelect?: boolean;
}

export default function SimpleSelectComponent({
  handleChange,
  handleBlur,
  options,
  isDisabled,
  label,
  limit = null,
  value = [],
  error = '',
  isMultiSelect = false
}: IHorizontalSelectProps) {
  const customSingleRender = ({ checked, option, onClick, disabled }) => (
    <div className={`item-renderer ${disabled && 'disabled'}`}>
      <input
        type='radio'
        onChange={onClick}
        checked={checked}
        tabIndex={-1}
        disabled={disabled}
      />
      <span>{option.label}</span>
    </div>
  );
  return (
    <Grid
      className={`filter-div ${isDisabled ? 'disabled-filter-div' : ''}`}
      sx={{ width: '100%' }}
    >
      {isMultiSelect ? (
        <MultiSelect
          options={alphanumericSort(options)}
          value={value}
          hasSelectAll={!limit}
          // passing filter name, value and it's position/index
          onChange={handleChange}
          labelledBy={label}
          className='multi-select-div limited-height'
          overrideStrings={{
            allItemsAreSelected: 'All'
          }}
          disabled={isDisabled}
          onMenuToggle={handleBlur}
        />
      ) : (
        <MultiSelect
          options={alphanumericSort(options)}
          value={value}
          hasSelectAll={false}
          onChange={(values: ISelectOption[]) => handleChange(values.slice(-1))}
          labelledBy={label}
          className='multi-select-div limited-height'
          ItemRenderer={customSingleRender}
          overrideStrings={{
            // eslint-disable-next-line dot-notation
            allItemsAreSelected: value['label']
          }}
          closeOnChangedValue
          onMenuToggle={handleBlur}
        />
      )}
      {error ? (
        <Typography fontSize='10px' color='red'>
          {error}
        </Typography>
      ) : null}
    </Grid>
  );
}
